<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2021.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2021-09-14                                                         -
  ----------------------------------------------------------------------------->

<template>
  <div>
    <b-container style="margin-top: 70px">
      <accessories-list>
        <template v-slot:cardbody="data">
          <b-card no-body>
            <b-card-body class="py-2">
              <div class="d-flex justify-content-between">
                <h4 class="text-danger">{{ data.item.attribute_store['short-name'] }}</h4>
                <b-button variant="link" :to="{name:'configure_accessories_path',params: {quote_version_id:quote_version_id,quote_part_id: quote_part_id,template_id:data.item.id}}">{{ data.item.attribute_store['long-description'] }}</b-button>
              </div>
            </b-card-body>
          </b-card>
        </template>
      </accessories-list>
      <bto-templates-list>
        <template v-slot:cardbody="data">
          <b-card no-body class="p-1">
            <b-container fluid>
              <b-row>
                <b-col sm="12" md="12" lg="12" xl="2"><h6 class="text-danger font-weight-bold">{{ data.item.attribute_store['short-name'] }}</h6></b-col>
                <b-col sm="12" md="12" lg="12" xl="9"><b-button variant="link" :to="{name:'configure_bto_path', params: {quote_version_id:quote_version_id,quote_part_id: quote_part_id,template_id:data.item.id}}">{{ data.item.attribute_store['long-description'] }}</b-button></b-col>
                <b-col sm="12" md="12" xg="12" xl="1"><span><b-badge>{{ formatCurrency(data.item.attribute_store['anchor-price']) }}</b-badge></span></b-col>
              </b-row>
            </b-container>
          </b-card>
        </template>
      </bto-templates-list>
    </b-container>
  </div>
</template>

<script>
import AccessoriesList from "./accessories-list.vue";
import BtoTemplatesList from "./bto-templates-list.vue";
import Yega1AxiosShowDataSource from "../yega/yega1/yega1-axios-show-data-source.vue";
import useCurrencyFormatter from "../../compositions/use-currency-formatter";

export default {
  name: "product-selection",
  components: {
    Yega1AxiosShowDataSource,
    BtoTemplatesList,
    AccessoriesList
  },
  props:{
    useCurrentUser:{
      type: Boolean,
      default:false
    }
  },
  setup(){
    const { formatCurrency } = useCurrencyFormatter();
    return {
      formatCurrency
    };
  },
  data() {
    return {
      CurrentUserStore:this.$store.state.CurrentUserStore
    };
  },
  computed:{
    quote_version_id(){
      if(this.useCurrentUser){
        return this.CurrentUserStore.user.current_quote_version_id;
      }else{
        return this.$route.params.quote_version_id;
      }
    },
    quote_part_id(){
      if(this.useCurrentUser){
        return this.CurrentUserStore.user.current_quote_part_id;
      }else{
        return this.$route.params.quote_part_id;
      }
    }
  }
}
</script>

<style scoped>

</style>
